import * as React from "react";
import { style } from "typestyle";

interface IProps {
  size: number;
  color?: string;
  rotation?: number;
}

export const GlobeIcon = (props: IProps) => {
  const className = style({
    width: props.size,
    height: props.size,
    stroke: props.color,
    transform: `rotate(${props.rotation}deg)`
  });
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        className={className}
      >
        <g
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        >
          <circle cx="24" cy="24" r="22" />
          <path d="M24 2v44M43 14H5M43 34H5M23.11 2c7.233 4.648 12.023 12.764 12.023 22s-4.79 17.352-12.023 22" />
          <path d="M24.133 46C16.901 41.352 12.11 33.236 12.11 24S16.901 6.648 24.133 2" />
        </g>
      </svg>
    </React.Fragment>
  );
};
